$(document).ready(function() {

    const $videoWrap = $(".js-video-wrap"),
        $play = $(".js-video-play");

    if($videoWrap.length){

        $play.on("click", function() {
            const parent = $(this).parents(".js-video-wrap");

            $(this).fadeOut();
            parent.find(".play").hide();
            parent.find(".overlay").fadeOut();
            parent.find(".js-video").get(0).play();
            parent.find(".js-video").attr("controls", "");
        });

    }
});